// Shared risk clauses catalog — used by BOTH Operations (auditor applies them
// per shift/area entry) and Finance (aggregates them for the day to reduce the
// projected income). Order matters — highest severity first.
export const CLAUSES = [
  { k: "avance_bajo_85",       l: "Avance < 85% (NO SE PAGA)",     severity: "critical" },
  { k: "afines_desbordes",     l: "Afines / desbordes NO PAGADOS", severity: "critical" },
  { k: "danos_llantas",        l: "Daños en llantas",              severity: "high" },
  { k: "danos_equipo",         l: "Daño a equipo",                 severity: "high" },
  { k: "danos_servicios",      l: "Daños a servicios mina",        severity: "med"  },
  { k: "desperdicio_materiales", l: "Desperdicio de materiales",   severity: "med"  },
  { k: "sobreexcavacion",      l: "Sobreexcavación",               severity: "med"  },
  { k: "orden_limpieza",       l: "Falta orden y limpieza",        severity: "low"  },
];

export const CLAUSE_TONE = {
  critical: "ring-red-400 bg-red-50",
  high:     "ring-orange-400 bg-orange-50",
  med:      "ring-amber-400 bg-amber-50",
  low:      "ring-slate-400 bg-slate-100",
};
